<a routerLink="/">Home</a> / Accounts <br/><br/>
<div class="row page-header">
  <div class="col title">
    <h1>Accounts</h1>
  </div>
</div>
<div class="grid-controls">
  <div class="search">
    <mat-form-field class="w-100 pr-5 no-subscript" appearance="outline">
      <mat-label>Search by name or email</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="searchText"
        (keyup)="onSearch()"
      />
      <button
        *ngIf="searchText"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="onSearchClear()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="table-wrapper mat-elevation-z3">
      <div class="table-progress-overlay" *ngIf="dataSource.loading | async">
        <mat-progress-spinner mode="indeterminate" diameter="50">
        </mat-progress-spinner>
      </div>
      <table
        [dataSource]="dataSource"
        mat-table
        matSort
        [matSortActive]="sortActiveDefault"
        [matSortDirection]="sortDirectionDefault"
        matSortDisableClear
      >
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="['/accounts/', element.id]"
            >{{ element.email }}
            </a>
          </td>
        </ng-container>
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>First name</th>
          <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
        </ng-container>
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last name</th>
          <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
        </ng-container>
        <ng-container matColumnDef="language">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Lang</th>
          <td mat-cell *matCellDef="let element">{{ element.language.toUpperCase() }}</td>
        </ng-container>
        <ng-container matColumnDef="roles">
          <th mat-header-cell *matHeaderCellDef>Roles</th>
          <td mat-cell *matCellDef="let element">{{ element.roles.join(', ') }}</td>
        </ng-container>
        <ng-container matColumnDef="isB2bUser">
          <th mat-header-cell *matHeaderCellDef>B2B</th>
          <td mat-cell *matCellDef="let element">{{ element.isB2bUser ? 'Yes' : '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created at</th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdAt | date : "dd MMM yyyy hh:mm" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="lastActivity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last activity</th>
          <td mat-cell *matCellDef="let element">
            {{ (element.lastActivity | fromNow) || "-" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let element">
            <mat-icon (click)="onRemoveAction(element.id, element.email)" class="text-danger--hover"
            >delete
            </mat-icon
            >
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="tableColumns.length">
            No data
          </td>
        </tr>
      </table>
      <mat-paginator
        [length]="totalItems"
        [pageSizeOptions]="pageSizeOptions"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>
</div>
